import { useNavigate } from "react-router-dom";

import ConfirmationQuestion from "../../../components/Questions/ConfirmationQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import { questionContent } from "../questions";

const Sight: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer: ConfirmationAnswer) => {
    setAnswers({
      ...answers,
      sight: answer,
      ...(answer !== ConfirmationAnswer.Yes
        ? {
            sightDetail: undefined,
          }
        : {}),
    });
  };

  const onContinue = () => {
    if (answers.sight === ConfirmationAnswer.Yes) {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.SightDetail}`);
    } else {
      navigate(`/${PATHS.About}/${ABOUT_ROUTES.Hearing}`);
    }
  };

  return (
    <ConfirmationQuestion
      onChange={onChange}
      value={answers.sight}
      onContinue={onContinue}
      step={questionContent.sight.step}
      title={questionContent.sight.title}
      subTitle={questionContent.sight.subTitle}
      whyWeWantTexts={questionContent.sight.whyWeWantTextsCustomer}
    />
  );
};

export default Sight;
